import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  toString1pkumu07cwy4m as toString,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  interpolate35pbs3ac913y4 as interpolate,
  _Ratio___init__impl__9mwvn21qwyi4zg9z4fu as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epzewvz4wcchi2m as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y3ofskh6zksge6 as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2ienc31uw6ixghmhkm as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default1fay4lgiuix8d as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.c9g_1 = Anchor2D.n9g(0.0, 0.0);
    this.d9g_1 = Anchor2D.n9g(0.5, 0.0);
    this.e9g_1 = Anchor2D.n9g(1.0, 0.0);
    this.f9g_1 = Anchor2D.n9g(0.0, 0.5);
    this.g9g_1 = Anchor2D.n9g(0.5, 0.5);
    this.h9g_1 = Anchor2D.n9g(1.0, 0.5);
    this.i9g_1 = Anchor2D.n9g(0.0, 1.0);
    this.j9g_1 = Anchor2D.n9g(0.5, 1.0);
    this.k9g_1 = Anchor2D.n9g(1.0, 1.0);
  }
  o9g() {
    return this.g9g_1;
  }
}
class Anchor2D {
  constructor(sx, sy) {
    return new.target.p9g(sx, sy);
  }
  static p9g(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.l9g_1 = sx;
    $this.m9g_1 = sy;
    return $this;
  }
  q9g() {
    return Vector2D.t9g(this.l9g_1, this.m9g_1);
  }
  static n9g(sx, sy) {
    Companion_getInstance();
    return this.p9g(sx, sy);
  }
  u9g(ratio, other) {
    return Anchor2D.p9g(interpolate(ratio, this.l9g_1, other.l9g_1), interpolate(ratio, this.m9g_1, other.m9g_1));
  }
  u9f(ratio, other) {
    return this.u9g(ratio, other instanceof Anchor2D ? other : THROW_CCE());
  }
  toString() {
    return 'Anchor2D(sx=' + this.l9g_1 + ', sy=' + this.m9g_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.l9g_1);
    result = imul(result, 31) + getNumberHashCode(this.m9g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.l9g_1, tmp0_other_with_cast.l9g_1))
      return false;
    if (!equals(this.m9g_1, tmp0_other_with_cast.m9g_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio = toRatio(1.0E-5);
    var tmp$ret$1 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.w9g_1 = _Angle___init__impl__g23q1m(tmp$ret$1);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio(0.0);
    var tmp$ret$3 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.x9g_1 = _Angle___init__impl__g23q1m(tmp$ret$3);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_1 = toRatio(0.25);
    var tmp$ret$5 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.y9g_1 = _Angle___init__impl__g23q1m(tmp$ret$5);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_2 = toRatio(0.5);
    var tmp$ret$7 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.z9g_1 = _Angle___init__impl__g23q1m(tmp$ret$7);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_3 = toRatio(0.75);
    var tmp$ret$9 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.a9h_1 = _Angle___init__impl__g23q1m(tmp$ret$9);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_4 = toRatio(1.0);
    var tmp$ret$11 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.b9h_1 = _Angle___init__impl__g23q1m(tmp$ret$11);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.v9g_1 = radians;
  }
  c9h(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.v9g_1, other, epsilon);
  }
  l9f(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  d9h(other) {
    return Angle__compareTo_impl_a0hfds(this.v9g_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.v9g_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.v9g_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.v9g_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.z9h_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().d9i());
  }
  e9i() {
    return this.z9h_1;
  }
  f9i(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().i9i(Companion_getInstance_18().g9i(p1, p2, p3, p4), Companion_getInstance_18().h9i(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.r9i_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.r9i_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.r9i_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.r9i_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.s9i_1 = center;
    this.t9i_1 = radius;
  }
  u9i() {
    return this.t9i_1 * this.t9i_1;
  }
  v9i(p) {
    return Companion_getInstance_18().w9i(p, this.s9i_1);
  }
  x9i(p) {
    return this.v9i(p) - this.u9i();
  }
  y9i(p) {
    return this.v9i(p) + this.u9i();
  }
  toString() {
    return 'Circle(center=' + this.s9i_1.toString() + ', radius=' + this.t9i_1 + ')';
  }
  hashCode() {
    var result = this.s9i_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.t9i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.s9i_1.equals(tmp0_other_with_cast.s9i_1))
      return false;
    if (!equals(this.t9i_1, tmp0_other_with_cast.t9i_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.a9j_1 = $index;
    this.b9j_1 = this$0;
    this.z9i_1 = $index;
  }
  q1() {
    return this.z9i_1 >= this.b9j_1.f9j_1;
  }
  r1() {
    var _unary__edvuaz = this.z9i_1;
    this.z9i_1 = _unary__edvuaz + 1 | 0;
    return this.b9j_1.u2(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.c9j_1 = list;
    this.d9j_1 = fromIndex;
    this.e9j_1 = toIndex;
    this.f9j_1 = this.e9j_1 - this.d9j_1 | 0;
  }
  s2() {
    return this.f9j_1;
  }
  u2(index) {
    return this.c9j_1.u2(index + this.d9j_1 | 0);
  }
  n1() {
    return this.f9j_1 === 0;
  }
  p1() {
    return this.s4();
  }
  s4() {
    return this.x2(0);
  }
  x2(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  t4(fromIndex, toIndex) {
    return new Sublist(this.c9j_1, this.d9j_1 + fromIndex | 0, this.d9j_1 + toIndex | 0);
  }
  g9j(element) {
    return Companion_instance_3.h9j(this.c9j_1, element, this.d9j_1, this.e9j_1, -this.d9j_1 | 0);
  }
  y2(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.g9j(element instanceof Vector2D ? element : THROW_CCE());
  }
  i9j(elements) {
    return Companion_instance_3.j9j(this, elements);
  }
  r4(elements) {
    return this.i9j(elements);
  }
  k9j(element) {
    return this.g9j(element) >= 0;
  }
  w2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.k9j(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  j9j(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = _this__u8e3s4.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!s.w2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  h9j(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.l9j(n) === element.r9g_1 && list.m9j(n) === element.s9g_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
  n9j(list, element, fromIndex, toIndex, offset, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? list.s2() : toIndex;
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.h9j(list, element, fromIndex, toIndex, offset) : $super.h9j.call(this, list, element, fromIndex, toIndex, offset);
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.s2() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.s2() === other.s2()))
    return false;
  if (!(this.r9j() === other.r9j()))
    return false;
  var inductionVariable = 0;
  var last = this.r9j();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.s2();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.p9j(n, dim), other.p9j(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.t9g(this.l9j(index), this.m9j(index));
}
function containsAll(elements) {
  return Companion_instance_3.j9j(this, elements);
}
function indexOf(element) {
  return Companion_instance_3.n9j(this, element);
}
function iterator() {
  return this.s4();
}
function listIterator() {
  return this.x2(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.s2())).x2(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.s9j_1 = Line2D.w9j(Companion_getInstance_18().g9h_1, Companion_getInstance_18().g9h_1);
    this.t9j_1 = Line2D.w9j(Companion_getInstance_18().h9h_1, Companion_getInstance_18().h9h_1);
  }
}
class Line2D {
  constructor(a, b) {
    return new.target.w9j(a, b);
  }
  static w9j(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.u9j_1 = a;
    $this.v9j_1 = b;
    return $this;
  }
  static x9j() {
    Companion_getInstance_4();
    return this.w9j(Vector2D.y9j(), Vector2D.y9j());
  }
  static z9j(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.w9j(Vector2D.a9k(x0, y0), Vector2D.a9k(x1, y1));
  }
  b9k() {
    return this.u9j_1.r9g_1;
  }
  c9k() {
    return this.u9j_1.s9g_1;
  }
  d9k() {
    return this.v9j_1.r9g_1;
  }
  e9k() {
    return this.v9j_1.s9g_1;
  }
  toString() {
    return 'Line(' + this.u9j_1.toString() + ', ' + this.v9j_1.toString() + ')';
  }
  hashCode() {
    var result = this.u9j_1.hashCode();
    result = imul(result, 31) + this.v9j_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.u9j_1.equals(tmp0_other_with_cast.u9j_1))
      return false;
    if (!this.v9j_1.equals(tmp0_other_with_cast.v9j_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.f9k_1 = new Margin(0.0, 0.0, 0.0, 0.0);
  }
}
class Margin {
  constructor(top, right, bottom, left) {
    Companion_getInstance_5();
    this.g9k_1 = top;
    this.h9k_1 = right;
    this.i9k_1 = bottom;
    this.j9k_1 = left;
  }
  k9k(other, epsilon) {
    return isAlmostEquals(this.j9k_1, other.j9k_1, epsilon) && isAlmostEquals(this.h9k_1, other.h9k_1, epsilon) && isAlmostEquals(this.g9k_1, other.g9k_1, epsilon) && isAlmostEquals(this.i9k_1, other.i9k_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.k9k(other instanceof Margin ? other : THROW_CCE(), epsilon);
  }
  l9k() {
    return this.j9k_1 + this.h9k_1;
  }
  m9k() {
    return this.g9k_1 + this.i9k_1;
  }
  toString() {
    return 'Margin(top=' + get_niceStr(this.g9k_1) + ', right=' + get_niceStr(this.h9k_1) + ', bottom=' + get_niceStr(this.i9k_1) + ', left=' + get_niceStr(this.j9k_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.g9k_1);
    result = imul(result, 31) + getNumberHashCode(this.h9k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i9k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j9k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Margin))
      return false;
    var tmp0_other_with_cast = other instanceof Margin ? other : THROW_CCE();
    if (!equals(this.g9k_1, tmp0_other_with_cast.g9k_1))
      return false;
    if (!equals(this.h9k_1, tmp0_other_with_cast.h9k_1))
      return false;
    if (!equals(this.i9k_1, tmp0_other_with_cast.i9k_1))
      return false;
    if (!equals(this.j9k_1, tmp0_other_with_cast.j9k_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.n9k_1 = MarginInt.s9k(0, 0, 0, 0);
  }
}
class MarginInt {
  constructor(top, right, bottom, left) {
    return new.target.s9k(top, right, bottom, left);
  }
  static s9k(top, right, bottom, left) {
    Companion_getInstance_6();
    var $this = createThis(this);
    $this.o9k_1 = top;
    $this.p9k_1 = right;
    $this.q9k_1 = bottom;
    $this.r9k_1 = left;
    return $this;
  }
  static t9k(margin) {
    Companion_getInstance_6();
    return this.s9k(margin, margin, margin, margin);
  }
  u9k() {
    return !(this.o9k_1 === 0) || !(this.r9k_1 === 0) || !(this.p9k_1 === 0) || !(this.q9k_1 === 0);
  }
  l9k() {
    return this.r9k_1 + this.p9k_1 | 0;
  }
  m9k() {
    return this.o9k_1 + this.q9k_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.o9k_1 + ', right=' + this.p9k_1 + ', bottom=' + this.q9k_1 + ', left=' + this.r9k_1 + ')';
  }
  hashCode() {
    var result = this.o9k_1;
    result = imul(result, 31) + this.p9k_1 | 0;
    result = imul(result, 31) + this.q9k_1 | 0;
    result = imul(result, 31) + this.r9k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.o9k_1 === tmp0_other_with_cast.o9k_1))
      return false;
    if (!(this.p9k_1 === tmp0_other_with_cast.p9k_1))
      return false;
    if (!(this.q9k_1 === tmp0_other_with_cast.q9k_1))
      return false;
    if (!(this.r9k_1 === tmp0_other_with_cast.r9k_1))
      return false;
    return true;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.v9k_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.w9k_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.x9k_1 = this.w9k_1;
  }
  y9k() {
    return this.v9k_1;
  }
  z9k(a, b, epsilon) {
    return isAlmostEquals(a.e9l_1, b.e9l_1, epsilon) && isAlmostEquals(a.f9l_1, b.f9l_1, epsilon) && isAlmostEquals(a.a9l_1, b.a9l_1, epsilon) && isAlmostEquals(a.b9l_1, b.b9l_1, epsilon) && isAlmostEquals(a.c9l_1, b.c9l_1, epsilon) && isAlmostEquals(a.d9l_1, b.d9l_1, epsilon);
  }
  g9l(l, r) {
    if (l.t9h())
      return r;
    if (r.t9h())
      return l;
    return new Matrix(l.a9l_1 * r.a9l_1 + l.b9l_1 * r.c9l_1, l.a9l_1 * r.b9l_1 + l.b9l_1 * r.d9l_1, l.c9l_1 * r.a9l_1 + l.d9l_1 * r.c9l_1, l.c9l_1 * r.b9l_1 + l.d9l_1 * r.d9l_1, l.e9l_1 * r.a9l_1 + l.f9l_1 * r.c9l_1 + r.e9l_1, l.e9l_1 * r.b9l_1 + l.f9l_1 * r.d9l_1 + r.f9l_1);
  }
  h9l(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_18().k9h_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_18().k9h_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_18().k9h_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_18().k9h_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  i9l(a, b, c, d, tx, ty, p) {
    return Vector2D.t9g(a * p.r9g_1 + c * p.s9g_1 + tx, d * p.s9g_1 + b * p.r9g_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_7();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.a9l_1 = a;
    this.b9l_1 = b;
    this.c9l_1 = c;
    this.d9l_1 = d;
    this.e9l_1 = tx;
    this.f9l_1 = ty;
  }
  j9l(other) {
    return Companion_getInstance_7().g9l(this, other);
  }
  t9h() {
    return isNaN_0(this.a9l_1);
  }
  u9h() {
    return !this.t9h();
  }
  k9l() {
    return this.a9l_1 === 1.0 && this.b9l_1 === 0.0 && this.c9l_1 === 0.0 && this.d9l_1 === 1.0 && this.e9l_1 === 0.0 && this.f9l_1 === 0.0;
  }
  d8o() {
    var hasRotation = !(this.b9l_1 === 0.0) || !(this.c9l_1 === 0.0);
    var hasScale = !(this.a9l_1 === 1.0) || !(this.d9l_1 === 1.0);
    var hasTranslation = !(this.e9l_1 === 0.0) || !(this.f9l_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  l9l(p) {
    return this.m9l(p.r9g_1, p.s9g_1);
  }
  n9l(x, y) {
    return this.m9l(x, y);
  }
  o9l(x, y) {
    return this.p9l(x, y);
  }
  m9l(x, y) {
    return this.a9l_1 * x + this.c9l_1 * y + this.e9l_1;
  }
  p9l(x, y) {
    return this.d9l_1 * y + this.b9l_1 * x + this.f9l_1;
  }
  q9l(x, y) {
    return this.m9l(x, y);
  }
  r9l(x, y) {
    return this.p9l(x, y);
  }
  s9l(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_18().k9h_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_18().k9h_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.a9l_1 * cos - this.b9l_1 * sin;
    var b = this.a9l_1 * sin + this.b9l_1 * cos;
    var a = a1;
    var c1 = this.c9l_1 * cos - this.d9l_1 * sin;
    var d = this.c9l_1 * sin + this.d9l_1 * cos;
    var c = c1;
    var tx1 = this.e9l_1 * cos - this.f9l_1 * sin;
    var ty = this.e9l_1 * sin + this.f9l_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  t9l(scaleX, scaleY) {
    return this.u9l(scaleX, scaleY);
  }
  u9l(scaleX, scaleY) {
    return new Matrix(this.a9l_1 * scaleX, this.b9l_1 * scaleX, this.c9l_1 * scaleY, this.d9l_1 * scaleY, this.e9l_1 * scaleX, this.f9l_1 * scaleY);
  }
  v9l(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.u9l(scaleX, scaleY) : $super.u9l.call(this, scaleX, scaleY);
  }
  w9l(scaleX, scaleY) {
    return new Matrix(this.a9l_1 * scaleX, this.b9l_1 * scaleX, this.c9l_1 * scaleY, this.d9l_1 * scaleY, this.e9l_1, this.f9l_1);
  }
  x9l(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.w9l(scaleX, scaleY) : $super.w9l.call(this, scaleX, scaleY);
  }
  y9l(delta) {
    return new Matrix(this.a9l_1, this.b9l_1, this.c9l_1, this.d9l_1, this.e9l_1 + delta.r9g_1, this.f9l_1 + delta.s9g_1);
  }
  z9l(x, y) {
    return this.y9l(Vector2D.a9k(x, y));
  }
  a9m(x, y) {
    return this.y9l(Vector2D.t9g(x, y));
  }
  b9m(delta) {
    return new Matrix(this.a9l_1, this.b9l_1, this.c9l_1, this.d9l_1, this.e9l_1 + (this.a9l_1 * delta.r9g_1 + this.c9l_1 * delta.s9g_1), this.f9l_1 + (this.b9l_1 * delta.r9g_1 + this.d9l_1 * delta.s9g_1));
  }
  c9m(deltaX, deltaY) {
    return this.b9m(Vector2D.d9m(deltaX, deltaY));
  }
  e9m(deltaX, deltaY) {
    return this.b9m(Vector2D.t9g(deltaX, deltaY));
  }
  f9m(m) {
    return m.j9l(this);
  }
  g9m() {
    return this;
  }
  h9m() {
    if (this.t9h())
      return Companion_getInstance_7().v9k_1;
    var m = this;
    var norm = m.a9l_1 * m.d9l_1 - m.b9l_1 * m.c9l_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.e9l_1, -m.f9l_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.a9l_1 * inorm;
      var a = m.d9l_1 * inorm;
      var b = m.b9l_1 * -inorm;
      var c = m.c9l_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.e9l_1 - c * m.f9l_1, -b * m.e9l_1 - d * m.f9l_1);
    }
    return tmp;
  }
  i9m() {
    return this.j9m();
  }
  j9m() {
    return Companion_getInstance_8().l9m(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.a9l_1) + ', ' + get_niceStr(this.b9l_1) + ', ' + get_niceStr(this.c9l_1) + ', ' + get_niceStr(this.d9l_1) + ', ' + get_niceStr(this.e9l_1) + ', ' + get_niceStr(this.f9l_1) + ')';
  }
  m9m(other, epsilon) {
    return Companion_getInstance_7().z9k(this, other, epsilon);
  }
  l9f(other, epsilon) {
    return this.m9m(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  n9m(other) {
    return this.j9l(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.a9l_1);
    result = imul(result, 31) + getNumberHashCode(this.b9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f9l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.a9l_1, tmp0_other_with_cast.a9l_1))
      return false;
    if (!equals(this.b9l_1, tmp0_other_with_cast.b9l_1))
      return false;
    if (!equals(this.c9l_1, tmp0_other_with_cast.c9l_1))
      return false;
    if (!equals(this.d9l_1, tmp0_other_with_cast.d9l_1))
      return false;
    if (!equals(this.e9l_1, tmp0_other_with_cast.e9l_1))
      return false;
    if (!equals(this.f9l_1, tmp0_other_with_cast.f9l_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.k9m_1 = MatrixTransform.v9m(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().x9g_1, Companion_getInstance_0().x9g_1, Companion_getInstance_0().x9g_1);
  }
  w9m(matrix, pivotX, pivotY) {
    var a = matrix.a9l_1;
    var b = matrix.b9l_1;
    var c = matrix.c9l_1;
    var d = matrix.d9l_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians(skewY);
      tskewX = get_radians(0.0);
      tskewY = get_radians(0.0);
    } else {
      trotation = get_radians_0(0);
      tskewX = get_radians(skewX);
      tskewY = get_radians(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.e9l_1;
      ty = matrix.f9l_1;
    } else {
      tx = matrix.e9l_1 + (pivotX * a + pivotY * c);
      ty = matrix.f9l_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.v9m(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  l9m(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.w9m(matrix, pivotX, pivotY) : $super.w9m.call(this, matrix, pivotX, pivotY);
  }
  x9m(a, b, epsilon) {
    return isAlmostEquals(a.o9m_1, b.o9m_1, epsilon) && isAlmostEquals(a.p9m_1, b.p9m_1, epsilon) && isAlmostEquals(a.q9m_1, b.q9m_1, epsilon) && isAlmostEquals(a.r9m_1, b.r9m_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.s9m_1, b.s9m_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.t9m_1, b.t9m_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.u9m_1, b.u9m_1, epsilon);
  }
}
class MatrixTransform {
  constructor(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    return new.target.v9m(x, y, scaleX, scaleY, skewX, skewY, rotation);
  }
  static v9m(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_8();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().x9g_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().x9g_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().x9g_1 : rotation;
    var $this = createThis(this);
    $this.o9m_1 = x;
    $this.p9m_1 = y;
    $this.q9m_1 = scaleX;
    $this.r9m_1 = scaleY;
    $this.s9m_1 = skewX;
    $this.t9m_1 = skewY;
    $this.u9m_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.o9m_1) + ', y=' + get_niceStr(this.p9m_1) + ', scaleX=' + this.q9m_1 + ', scaleY=' + this.r9m_1 + ', skewX=' + Angle__toString_impl_786qky(this.s9m_1) + ', skewY=' + Angle__toString_impl_786qky(this.t9m_1) + ', rotation=' + Angle__toString_impl_786qky(this.u9m_1) + ')';
  }
  static y9m() {
    Companion_getInstance_8();
    return this.v9m(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().x9g_1, Companion_getInstance_0().x9g_1, Companion_getInstance_0().x9g_1);
  }
  z9m(other, epsilon) {
    return Companion_getInstance_8().x9m(this, other, epsilon);
  }
  l9f(other, epsilon) {
    return this.z9m(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  a9n() {
    return (this.q9m_1 + this.r9m_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.o9m_1);
    result = imul(result, 31) + getNumberHashCode(this.p9m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q9m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r9m_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.s9m_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.t9m_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.u9m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.o9m_1, tmp0_other_with_cast.o9m_1))
      return false;
    if (!equals(this.p9m_1, tmp0_other_with_cast.p9m_1))
      return false;
    if (!equals(this.q9m_1, tmp0_other_with_cast.q9m_1))
      return false;
    if (!equals(this.r9m_1, tmp0_other_with_cast.r9m_1))
      return false;
    if (!equals(this.s9m_1, tmp0_other_with_cast.s9m_1))
      return false;
    if (!equals(this.t9m_1, tmp0_other_with_cast.t9m_1))
      return false;
    if (!equals(this.u9m_1, tmp0_other_with_cast.u9m_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.d9n_1 = id;
    this.e9n_1 = hasRotation;
    this.f9n_1 = hasScale;
    this.g9n_1 = hasTranslation;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    this.h9n_1 = 0;
    this.i9n_1 = 1;
    this.j9n_1 = 2;
    this.k9n_1 = 3;
    this.l9n_1 = 4;
    this.m9n_1 = 5;
    this.n9n_1 = 6;
    this.o9n_1 = 7;
    this.p9n_1 = 8;
    this.q9n_1 = 9;
    this.r9n_1 = 10;
    this.s9n_1 = 11;
    this.t9n_1 = 12;
    this.u9n_1 = 13;
    this.v9n_1 = 14;
    this.w9n_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.x9n_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.y9n_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.z9n_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.a9o_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.b9o_1 = Matrix4.d9o();
  }
  e9o(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.f9o(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  g9o(l, r) {
    return Companion_getInstance_9().e9o(l.h9o() * r.h9o() + l.i9o() * r.j9o() + l.k9o() * r.l9o() + l.m9o() * r.n9o(), l.h9o() * r.i9o() + l.i9o() * r.o9o() + l.k9o() * r.p9o() + l.m9o() * r.q9o(), l.h9o() * r.k9o() + l.i9o() * r.r9o() + l.k9o() * r.s9o() + l.m9o() * r.t9o(), l.h9o() * r.m9o() + l.i9o() * r.u9o() + l.k9o() * r.v9o() + l.m9o() * r.w9o(), l.j9o() * r.h9o() + l.o9o() * r.j9o() + l.r9o() * r.l9o() + l.u9o() * r.n9o(), l.j9o() * r.i9o() + l.o9o() * r.o9o() + l.r9o() * r.p9o() + l.u9o() * r.q9o(), l.j9o() * r.k9o() + l.o9o() * r.r9o() + l.r9o() * r.s9o() + l.u9o() * r.t9o(), l.j9o() * r.m9o() + l.o9o() * r.u9o() + l.r9o() * r.v9o() + l.u9o() * r.w9o(), l.l9o() * r.h9o() + l.p9o() * r.j9o() + l.s9o() * r.l9o() + l.v9o() * r.n9o(), l.l9o() * r.i9o() + l.p9o() * r.o9o() + l.s9o() * r.p9o() + l.v9o() * r.q9o(), l.l9o() * r.k9o() + l.p9o() * r.r9o() + l.s9o() * r.s9o() + l.v9o() * r.t9o(), l.l9o() * r.m9o() + l.p9o() * r.u9o() + l.s9o() * r.v9o() + l.v9o() * r.w9o(), l.n9o() * r.h9o() + l.q9o() * r.j9o() + l.t9o() * r.l9o() + l.w9o() * r.n9o(), l.n9o() * r.i9o() + l.q9o() * r.o9o() + l.t9o() * r.p9o() + l.w9o() * r.q9o(), l.n9o() * r.k9o() + l.q9o() * r.r9o() + l.t9o() * r.s9o() + l.w9o() * r.t9o(), l.n9o() * r.m9o() + l.q9o() * r.u9o() + l.t9o() * r.v9o() + l.w9o() * r.w9o());
  }
  x9o(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_9().e9o(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  y9o(left, right, bottom, top, near, far) {
    return this.x9o(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  constructor(data) {
    return new.target.z9o(data);
  }
  static z9o(data) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.c9o_1 = data;
    // Inline function 'kotlin.check' call
    if (!($this.c9o_1.length === 16)) {
      throw IllegalStateException.o('Check failed.');
    }
    return $this;
  }
  h9o() {
    return this.c9o_1[0];
  }
  j9o() {
    return this.c9o_1[1];
  }
  l9o() {
    return this.c9o_1[2];
  }
  n9o() {
    return this.c9o_1[3];
  }
  i9o() {
    return this.c9o_1[4];
  }
  o9o() {
    return this.c9o_1[5];
  }
  p9o() {
    return this.c9o_1[6];
  }
  q9o() {
    return this.c9o_1[7];
  }
  k9o() {
    return this.c9o_1[8];
  }
  r9o() {
    return this.c9o_1[9];
  }
  s9o() {
    return this.c9o_1[10];
  }
  t9o() {
    return this.c9o_1[11];
  }
  m9o() {
    return this.c9o_1[12];
  }
  u9o() {
    return this.c9o_1[13];
  }
  v9o() {
    return this.c9o_1[14];
  }
  w9o() {
    return this.c9o_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.c9o_1, other.c9o_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.c9o_1);
  }
  a9p(that) {
    return Companion_getInstance_9().g9o(this, that);
  }
  static f9o(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_9();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.z9o(tmp$ret$0);
  }
  static d9o() {
    Companion_getInstance_9();
    return this.f9o(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  p9j(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.o(toString(message));
    }
    return this.c9o_1[imul(row, 4) + column | 0];
  }
  b9p(index) {
    if (!(0 <= index ? index <= (this.c9o_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.o(toString(message));
    }
    return this.c9o_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.m1('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.m1(', ');
            }
            var v = this.p9j(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.kh(numberToInt(v));
            else {
              this_0.mh(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.m1(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.m1(')');
    return this_0.toString();
  }
}
class Companion_10 {
  constructor() {
    this.e9h_1 = 1.0E-7;
  }
  f9h(up) {
    var tmp;
    if (up.r9g_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.s9g_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.o(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.h9p_1 = value;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp.i9p_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_0.j9p_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_1.k9p_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var corner = -1.0;
    tmp_2.l9p_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_3.m9p_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_11();
    this.n9p_1 = topLeft;
    this.o9p_1 = topRight;
    this.p9p_1 = bottomRight;
    this.q9p_1 = bottomLeft;
  }
  toString() {
    return 'RectCorners(topLeft=' + this.n9p_1 + ', topRight=' + this.o9p_1 + ', bottomRight=' + this.p9p_1 + ', bottomLeft=' + this.q9p_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.n9p_1);
    result = imul(result, 31) + getNumberHashCode(this.o9p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p9p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q9p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.n9p_1, tmp0_other_with_cast.n9p_1))
      return false;
    if (!equals(this.o9p_1, tmp0_other_with_cast.o9p_1))
      return false;
    if (!equals(this.p9p_1, tmp0_other_with_cast.p9p_1))
      return false;
    if (!equals(this.q9p_1, tmp0_other_with_cast.q9p_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.a9i_1 = Companion_getInstance_12().r9p(0, 0, 0, 0);
    this.b9i_1 = Companion_getInstance_12().s9p(-Infinity, -Infinity, Infinity, Infinity);
    this.c9i_1 = Companion_getInstance_12().s9p(NaN, NaN, 0.0, 0.0);
  }
  d9i() {
    return this.c9i_1;
  }
  y9k() {
    return this.a9i_1;
  }
  m9i(p, s) {
    return new Rectangle(p.r9g_1, p.s9g_1, s.j9i_1, s.k9i_1);
  }
  r9p(x, y, width, height) {
    return Companion_getInstance_12().m9i(Vector2D.a9k(x, y), Size2D.l9i(width, height));
  }
  s9p(x, y, width, height) {
    return Companion_getInstance_12().m9i(Vector2D.d9m(x, y), Size2D.t9p(width, height));
  }
  u9p(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  v9p(left, top, right, bottom) {
    return this.u9p(left, top, right, bottom);
  }
  i9i(point1, point2) {
    var tmp = Companion_getInstance_12();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.t9g(point2.r9g_1 - point1.r9g_1, point2.s9g_1 - point1.s9g_1);
    return tmp.m9i(point1, toSize(tmp$ret$0));
  }
  w9p(a, b) {
    return a.o9h_1 >= b.o9h_1 && a.p9h_1 >= b.p9h_1 && a.o9h_1 + a.q9h_1 <= b.o9h_1 + b.q9h_1 && a.p9h_1 + a.r9h_1 <= b.p9h_1 + b.r9h_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_12();
    this.o9h_1 = x;
    this.p9h_1 = y;
    this.q9h_1 = width;
    this.r9h_1 = height;
    this.s9h_1 = true;
  }
  g9m() {
    return this;
  }
  x9p() {
    return this;
  }
  s2() {
    return Size2D.y9p(this.q9h_1, this.r9h_1);
  }
  z9p() {
    return isNaN_0(this.o9h_1);
  }
  t9h() {
    return this.z9p();
  }
  u9h() {
    return !this.t9h();
  }
  a9q(other, epsilon) {
    return isAlmostEquals(this.o9h_1, other.o9h_1, epsilon) && isAlmostEquals(this.p9h_1, other.p9h_1, epsilon) && isAlmostEquals(this.q9h_1, other.q9h_1, epsilon) && isAlmostEquals(this.r9h_1, other.r9h_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.a9q(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.t9h() ? 'null' : 'Rectangle(x=' + get_niceStr(this.o9h_1) + ', y=' + get_niceStr(this.p9h_1) + ', width=' + get_niceStr(this.q9h_1) + ', height=' + get_niceStr(this.r9h_1) + ')';
  }
  b9q(scale) {
    return new Rectangle(this.o9h_1 * scale, this.p9h_1 * scale, this.q9h_1 * scale, this.r9h_1 * scale);
  }
  k9j(that) {
    return this.c9q(that.r9g_1, that.s9g_1);
  }
  c9q(x, y) {
    return x >= this.v9h() && x < this.w9h() && (y >= this.x9h() && y < this.y9h());
  }
  v9h() {
    return this.o9h_1;
  }
  x9h() {
    return this.p9h_1;
  }
  w9h() {
    return this.o9h_1 + this.q9h_1;
  }
  y9h() {
    return this.p9h_1 + this.r9h_1;
  }
  n9i() {
    return Vector2D.t9g(this.v9h(), this.x9h());
  }
  d9q() {
    return Vector2D.t9g(this.w9h(), this.x9h());
  }
  e9q() {
    return Vector2D.t9g(this.v9h(), this.y9h());
  }
  p9i() {
    return Vector2D.t9g(this.w9h(), this.y9h());
  }
  f9q() {
    return (this.w9h() + this.v9h()) * 0.5;
  }
  g9q() {
    return (this.y9h() + this.x9h()) * 0.5;
  }
  h9q() {
    return Vector2D.t9g(this.f9q(), this.g9q());
  }
  i9q(padding) {
    return Companion_getInstance_12().u9p(this.v9h() + padding.j9k_1, this.x9h() + padding.g9k_1, this.w9h() - padding.h9k_1, this.y9h() - padding.i9k_1);
  }
  j9q(that) {
    return this.k9q(that) && this.l9q(that);
  }
  k9q(that) {
    return that.v9h() <= this.w9h() && that.w9h() >= this.v9h();
  }
  l9q(that) {
    return that.x9h() <= this.y9h() && that.y9h() >= this.x9h();
  }
  m9q(that) {
    var tmp;
    if (this.j9q(that)) {
      var tmp0 = this.v9h();
      // Inline function 'kotlin.math.max' call
      var b = that.v9h();
      var tmp_0 = Math.max(tmp0, b);
      var tmp0_0 = this.x9h();
      // Inline function 'kotlin.math.max' call
      var b_0 = that.x9h();
      var tmp_1 = Math.max(tmp0_0, b_0);
      var tmp0_1 = this.w9h();
      // Inline function 'kotlin.math.min' call
      var b_1 = that.w9h();
      var tmp_2 = Math.min(tmp0_1, b_1);
      var tmp0_2 = this.y9h();
      // Inline function 'kotlin.math.min' call
      var b_2 = that.y9h();
      var tmp$ret$3 = Math.min(tmp0_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_12().d9i();
    }
    return tmp;
  }
  n9q() {
    return RectangleInt.s9q(numberToInt(this.o9h_1), numberToInt(this.p9h_1), numberToInt(this.q9h_1), numberToInt(this.r9h_1));
  }
  t9q(border) {
    return Companion_getInstance_12().u9p(this.v9h() - border.r9k_1, this.x9h() - border.o9k_1, this.w9h() + border.p9k_1, this.y9h() + border.q9k_1);
  }
  y9l(delta) {
    return this.u9q(this.o9h_1 + delta.r9g_1, this.p9h_1 + delta.s9g_1);
  }
  v9q(m) {
    var tmp2 = this.n9i();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (m.t9h()) {
        tmp$ret$0 = tmp2;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(m.m9l(tmp2.r9g_1, tmp2.s9g_1), m.p9l(tmp2.r9g_1, tmp2.s9g_1));
    }
    var tl = tmp$ret$0;
    var tmp2_0 = this.d9q();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (m.t9h()) {
        tmp$ret$1 = tmp2_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.t9g(m.m9l(tmp2_0.r9g_1, tmp2_0.s9g_1), m.p9l(tmp2_0.r9g_1, tmp2_0.s9g_1));
    }
    var tr = tmp$ret$1;
    var tmp2_1 = this.e9q();
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (m.t9h()) {
        tmp$ret$2 = tmp2_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.t9g(m.m9l(tmp2_1.r9g_1, tmp2_1.s9g_1), m.p9l(tmp2_1.r9g_1, tmp2_1.s9g_1));
    }
    var bl = tmp$ret$2;
    var tmp2_2 = this.p9i();
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (m.t9h()) {
        tmp$ret$3 = tmp2_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.t9g(m.m9l(tmp2_2.r9g_1, tmp2_2.s9g_1), m.p9l(tmp2_2.r9g_1, tmp2_2.s9g_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_18().g9i(tl, tr, bl, br);
    var max = Companion_getInstance_18().h9i(tl, tr, bl, br);
    return Companion_getInstance_12().i9i(min, max);
  }
  w9q() {
    return Companion_getInstance_12().i9i(Companion_getInstance_18().o9i(this.n9i(), this.p9i()), Companion_getInstance_18().q9i(this.n9i(), this.p9i()));
  }
  x9q(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  u9q(x, y, width, height, $super) {
    x = x === VOID ? this.o9h_1 : x;
    y = y === VOID ? this.p9h_1 : y;
    width = width === VOID ? this.q9h_1 : width;
    height = height === VOID ? this.r9h_1 : height;
    return $super === VOID ? this.x9q(x, y, width, height) : $super.x9q.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.o9h_1);
    result = imul(result, 31) + getNumberHashCode(this.p9h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q9h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r9h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.o9h_1, tmp0_other_with_cast.o9h_1))
      return false;
    if (!equals(this.p9h_1, tmp0_other_with_cast.p9h_1))
      return false;
    if (!equals(this.q9h_1, tmp0_other_with_cast.q9h_1))
      return false;
    if (!equals(this.r9h_1, tmp0_other_with_cast.r9h_1))
      return false;
    return true;
  }
}
class Companion_13 {
  z9q(a, b) {
    var tmp0 = a.v9h();
    // Inline function 'kotlin.math.min' call
    var b_0 = b.v9h();
    var tmp = Math.min(tmp0, b_0);
    var tmp0_0 = a.x9h();
    // Inline function 'kotlin.math.min' call
    var b_1 = b.x9h();
    var tmp_0 = Math.min(tmp0_0, b_1);
    var tmp0_1 = a.w9h();
    // Inline function 'kotlin.math.max' call
    var b_2 = b.w9h();
    var tmp_1 = Math.max(tmp0_1, b_2);
    var tmp0_2 = a.y9h();
    // Inline function 'kotlin.math.max' call
    var b_3 = b.y9h();
    var tmp$ret$3 = Math.max(tmp0_2, b_3);
    return this.v9p(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  a9r(topLeft, bottomRight) {
    var size = bottomRight.d9r(topLeft);
    return RectangleInt.s9q(topLeft.b9r_1, topLeft.c9r_1, size.b9r_1, size.c9r_1);
  }
  v9p(left, top, right, bottom) {
    return this.a9r(Vector2I.e9r(left, top), Vector2I.e9r(right, bottom));
  }
}
class RectangleInt {
  constructor(x, y, width, height) {
    return new.target.s9q(x, y, width, height);
  }
  static s9q(x, y, width, height) {
    var $this = createThis(this);
    $this.o9q_1 = x;
    $this.p9q_1 = y;
    $this.q9q_1 = width;
    $this.r9q_1 = height;
    return $this;
  }
  static f9r() {
    return this.s9q(0, 0, 0, 0);
  }
  g9r() {
    return imul(this.q9q_1, this.r9q_1);
  }
  v9h() {
    return this.o9q_1;
  }
  x9h() {
    return this.p9q_1;
  }
  w9h() {
    return this.o9q_1 + this.q9q_1 | 0;
  }
  y9h() {
    return this.p9q_1 + this.r9q_1 | 0;
  }
  h9r(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.q9q_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.q9q_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.r9q_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.r9q_1);
    return Companion_instance_13.v9p(this.o9q_1 + left_0 | 0, this.p9q_1 + top_0 | 0, this.o9q_1 + right_0 | 0, this.p9q_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.o9q_1 + ', y=' + this.p9q_1 + ', width=' + this.q9q_1 + ', height=' + this.r9q_1 + ')';
  }
  i9r() {
    return Companion_getInstance_12().r9p(this.o9q_1, this.p9q_1, this.q9q_1, this.r9q_1);
  }
  t9q(border) {
    return Companion_instance_13.v9p(this.v9h() - border.r9k_1 | 0, this.x9h() - border.o9k_1 | 0, this.w9h() + border.p9k_1 | 0, this.y9h() + border.q9k_1 | 0);
  }
  hashCode() {
    var result = this.o9q_1;
    result = imul(result, 31) + this.p9q_1 | 0;
    result = imul(result, 31) + this.q9q_1 | 0;
    result = imul(result, 31) + this.r9q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.o9q_1 === tmp0_other_with_cast.o9q_1))
      return false;
    if (!(this.p9q_1 === tmp0_other_with_cast.p9q_1))
      return false;
    if (!(this.q9q_1 === tmp0_other_with_cast.q9q_1))
      return false;
    if (!(this.r9q_1 === tmp0_other_with_cast.r9q_1))
      return false;
    return true;
  }
}
class Companion_14 {}
class RoundRectangle {
  constructor(rect, corners) {
    this.j9r_1 = rect;
    this.k9r_1 = corners;
  }
  toString() {
    return 'RoundRectangle(rect=' + this.j9r_1.toString() + ', corners=' + this.k9r_1.toString() + ')';
  }
  hashCode() {
    var result = this.j9r_1.hashCode();
    result = imul(result, 31) + this.k9r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RoundRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof RoundRectangle ? other : THROW_CCE();
    if (!this.j9r_1.equals(tmp0_other_with_cast.j9r_1))
      return false;
    if (!this.k9r_1.equals(tmp0_other_with_cast.k9r_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    this.l9r_1 = Scale.m9r(1.0, 1.0);
  }
}
class Scale {
  constructor(scaleX, scaleY) {
    return new.target.e9p(scaleX, scaleY);
  }
  static e9p(scaleX, scaleY) {
    Companion_getInstance_15();
    var $this = createThis(this);
    $this.c9p_1 = scaleX;
    $this.d9p_1 = scaleY;
    return $this;
  }
  a9n() {
    return this.c9p_1 * 0.5 + this.d9p_1 * 0.5;
  }
  static n9r() {
    Companion_getInstance_15();
    return this.m9r(1.0, 1.0);
  }
  static o9r(scale) {
    Companion_getInstance_15();
    return this.e9p(scale, scale);
  }
  static p9r(scale) {
    Companion_getInstance_15();
    return this.o9r(scale);
  }
  static m9r(scaleX, scaleY) {
    Companion_getInstance_15();
    return this.e9p(scaleX, scaleY);
  }
  static q9r(scaleX, scaleY) {
    Companion_getInstance_15();
    return this.e9p(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.c9p_1 + ', scaleY=' + this.d9p_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.c9p_1);
    result = imul(result, 31) + getNumberHashCode(this.d9p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.c9p_1, tmp0_other_with_cast.c9p_1))
      return false;
    if (!equals(this.d9p_1, tmp0_other_with_cast.d9p_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    tmp.u9r_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.v9r_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.w9r_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.x9r_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  y9r() {
    return this.w9r_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_16();
    name = name === VOID ? null : name;
    this.z9r_1 = name;
    this.a9s_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.z9r_1 + ')';
  }
  b9s(item, container) {
    return toInt(this.a9s_1(toFloat(item), toFloat(container)));
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.c9s_1 = Size2D.y9p(0.0, 0.0);
  }
}
class Size2D {
  constructor(width, height) {
    return new.target.y9p(width, height);
  }
  static y9p(width, height) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.j9i_1 = width;
    $this.k9i_1 = height;
    return $this;
  }
  static d9s() {
    Companion_getInstance_17();
    return this.y9p(0.0, 0.0);
  }
  static t9p(width, height) {
    Companion_getInstance_17();
    return this.y9p(width, height);
  }
  static l9i(width, height) {
    Companion_getInstance_17();
    return this.y9p(width, height);
  }
  e9s(other) {
    return Size2D.y9p(this.j9i_1 - other.j9i_1, this.k9i_1 - other.k9i_1);
  }
  f9s(other) {
    return Size2D.y9p(this.j9i_1 + other.j9i_1, this.k9i_1 + other.k9i_1);
  }
  g9s(scale) {
    return Size2D.y9p(this.j9i_1 * scale.c9p_1, this.k9i_1 * scale.d9p_1);
  }
  h9s(s) {
    return Size2D.y9p(this.j9i_1 * s, this.k9i_1 * s);
  }
  b9q(s) {
    return this.h9s(s);
  }
  i9s(s) {
    return this.h9s(s);
  }
  r9r(other) {
    return Scale.e9p(this.j9i_1 / other.j9i_1, this.k9i_1 / other.k9i_1);
  }
  j9s(s) {
    return Size2D.y9p(this.j9i_1 / s, this.k9i_1 / s);
  }
  k9s(s) {
    return this.j9s(s);
  }
  l9s(s) {
    return this.j9s(s);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.j9i_1) + ', height=' + get_niceStr(this.k9i_1) + ')';
  }
  jm() {
    return this.j9i_1;
  }
  km() {
    return this.k9i_1;
  }
  m9s(width, height) {
    return Size2D.y9p(width, height);
  }
  n9s(width, height, $super) {
    width = width === VOID ? this.j9i_1 : width;
    height = height === VOID ? this.k9i_1 : height;
    return $super === VOID ? this.m9s(width, height) : $super.m9s.call(this, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.j9i_1);
    result = imul(result, 31) + getNumberHashCode(this.k9i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.j9i_1, tmp0_other_with_cast.j9i_1))
      return false;
    if (!equals(this.k9i_1, tmp0_other_with_cast.k9i_1))
      return false;
    return true;
  }
}
class SizeInt {
  constructor(width, height) {
    return new.target.q9s(width, height);
  }
  static q9s(width, height) {
    var $this = createThis(this);
    $this.o9s_1 = width;
    $this.p9s_1 = height;
    return $this;
  }
  static r9s() {
    return this.q9s(0, 0);
  }
  toString() {
    return '' + this.o9s_1 + 'x' + this.p9s_1;
  }
  hashCode() {
    var result = this.o9s_1;
    result = imul(result, 31) + this.p9s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.o9s_1 === tmp0_other_with_cast.o9s_1))
      return false;
    if (!(this.p9s_1 === tmp0_other_with_cast.p9s_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.g9h_1 = Vector2D.t9g(0.0, 0.0);
    this.h9h_1 = Vector2D.t9g(NaN, NaN);
    this.i9h_1 = Vector2D.t9g(-1.0, 0.0);
    this.j9h_1 = Vector2D.t9g(+1.0, 0.0);
    this.k9h_1 = Vector2D.t9g(0.0, +1.0);
    this.l9h_1 = Vector2D.t9g(0.0, -1.0);
    this.m9h_1 = Vector2D.t9g(0.0, -1.0);
    this.n9h_1 = Vector2D.t9g(0.0, +1.0);
  }
  s9s(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var tmp2 = a.r9g_1;
    var tmp4 = a.s9g_1;
    var tmp6 = b.r9g_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var y1 = b.s9g_1;
    return Angle_between(tmp2, tmp4, tmp6, y1, up);
  }
  t9s(a, b, up, $super) {
    up = up === VOID ? this.k9h_1 : up;
    return $super === VOID ? this.s9s(a, b, up) : $super.s9s.call(this, a, b, up).v9g_1;
  }
  u9s(a, b, up) {
    Companion_getInstance_0();
    // Inline function 'kotlin.math.acos' call
    var x = a.v9s(b) / (a.a() * b.a());
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians = Math.acos(x);
    var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
    return adjustFromUp(tmp$ret$1, up);
  }
  w9s(a, b, up, $super) {
    up = up === VOID ? this.k9h_1 : up;
    return $super === VOID ? this.u9s(a, b, up) : $super.u9s.call(this, a, b, up).v9g_1;
  }
  y9q(x1, y1, x2, y2) {
    var tmp0 = x1 - x2;
    // Inline function 'kotlin.math.hypot' call
    var y = y1 - y2;
    return hypot(tmp0, y);
  }
  x9s(x1, y1, x2, y2) {
    var tmp0 = x1 - x2;
    // Inline function 'kotlin.math.hypot' call
    var y = y1 - y2;
    return hypot(tmp0, y);
  }
  y9s(x1, y1, x2, y2) {
    var tmp0 = x1 - x2;
    // Inline function 'kotlin.math.hypot' call
    var y = y1 - y2;
    return hypot(tmp0, y);
  }
  z9s(a, b) {
    return this.y9q(a.r9g_1, a.s9g_1, b.r9g_1, b.s9g_1);
  }
  w9i(a, b) {
    return this.a9t(a.r9g_1, a.s9g_1, b.r9g_1, b.s9g_1);
  }
  a9t(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  b9t(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  c9t(p1, p2) {
    return this.b9t(p1.r9g_1, p1.s9g_1, p2.r9g_1, p2.s9g_1);
  }
  o9i(p1, p2) {
    var tmp0 = p1.r9g_1;
    // Inline function 'kotlin.math.min' call
    var b = p2.r9g_1;
    var tmp = Math.min(tmp0, b);
    var tmp0_0 = p1.s9g_1;
    // Inline function 'kotlin.math.min' call
    var b_0 = p2.s9g_1;
    var tmp$ret$1 = Math.min(tmp0_0, b_0);
    return Vector2D.t9g(tmp, tmp$ret$1);
  }
  g9i(p1, p2, p3, p4) {
    return Vector2D.t9g(minOf(p1.r9g_1, new Float64Array([p2.r9g_1, p3.r9g_1, p4.r9g_1])), minOf(p1.s9g_1, new Float64Array([p2.s9g_1, p3.s9g_1, p4.s9g_1])));
  }
  q9i(p1, p2) {
    var tmp0 = p1.r9g_1;
    // Inline function 'kotlin.math.max' call
    var b = p2.r9g_1;
    var tmp = Math.max(tmp0, b);
    var tmp0_0 = p1.s9g_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = p2.s9g_1;
    var tmp$ret$1 = Math.max(tmp0_0, b_0);
    return Vector2D.t9g(tmp, tmp$ret$1);
  }
  h9i(p1, p2, p3, p4) {
    return Vector2D.t9g(maxOf(p1.r9g_1, new Float64Array([p2.r9g_1, p3.r9g_1, p4.r9g_1])), maxOf(p1.s9g_1, new Float64Array([p2.s9g_1, p3.s9g_1, p4.s9g_1])));
  }
}
class Vector2D {
  constructor(x, y) {
    return new.target.t9g(x, y);
  }
  static t9g(x, y) {
    Companion_getInstance_18();
    var $this = createThis(this);
    $this.r9g_1 = x;
    $this.s9g_1 = y;
    return $this;
  }
  static d9m(x, y) {
    Companion_getInstance_18();
    return this.t9g(x, y);
  }
  static a9k(x, y) {
    Companion_getInstance_18();
    return this.t9g(x, y);
  }
  static d9t(x, y) {
    Companion_getInstance_18();
    return this.t9g(x, y);
  }
  static e9t(x, y) {
    Companion_getInstance_18();
    return this.t9g(x, y);
  }
  static y9j() {
    Companion_getInstance_18();
    return this.t9g(0.0, 0.0);
  }
  t9r() {
    var tmp0 = this.r9g_1;
    // Inline function 'kotlin.math.min' call
    var b = this.s9g_1;
    return Math.min(tmp0, b);
  }
  s9r() {
    var tmp0 = this.r9g_1;
    // Inline function 'kotlin.math.max' call
    var b = this.s9g_1;
    return Math.max(tmp0, b);
  }
  f9t(x, y) {
    var tmp0 = x - this.r9g_1;
    // Inline function 'kotlin.math.hypot' call
    var y_0 = y - this.s9g_1;
    return hypot(tmp0, y_0);
  }
  g9t(that) {
    return this.f9t(that.r9g_1, that.s9g_1);
  }
  v9s(that) {
    return this.r9g_1 * that.r9g_1 + this.s9g_1 * that.s9g_1;
  }
  a() {
    var tmp0 = this.r9g_1;
    // Inline function 'kotlin.math.hypot' call
    var y = this.s9g_1;
    return hypot(tmp0, y);
  }
  h9t() {
    var x = this.r9g_1;
    var y = this.s9g_1;
    return x * x + y * y;
  }
  i9t() {
    var tmp0 = this.r9g_1;
    // Inline function 'kotlin.math.hypot' call
    var y = this.s9g_1;
    return hypot(tmp0, y);
  }
  j9t() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.i9t();
    return Vector2D.t9g(this.r9g_1 * scale, this.s9g_1 * scale);
  }
  k9t() {
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var scale = this.a();
    return Vector2D.t9g(this.r9g_1 / scale, this.s9g_1 / scale);
  }
  l9t() {
    return Vector2D.t9g(-this.s9g_1, this.r9g_1);
  }
  m9t(other, epsilon) {
    return isAlmostEquals(this.r9g_1, other.r9g_1, epsilon) && isAlmostEquals(this.s9g_1, other.s9g_1, epsilon);
  }
  l9f(other, epsilon) {
    return this.m9t(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  n9t() {
    return '(' + get_niceStr(this.r9g_1) + ', ' + get_niceStr(this.s9g_1) + ')';
  }
  toString() {
    return this.n9t();
  }
  jm() {
    return this.r9g_1;
  }
  km() {
    return this.s9g_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.r9g_1);
    result = imul(result, 31) + getNumberHashCode(this.s9g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.r9g_1, tmp0_other_with_cast.r9g_1))
      return false;
    if (!equals(this.s9g_1, tmp0_other_with_cast.s9g_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.o9t_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.p9t_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_19();
    this.q9t_1 = x;
    this.r9t_1 = y;
    this.s9t_1 = z;
    this.t9t_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.q9t_1) + ', ' + get_niceStr_0(this.r9t_1) + ', ' + get_niceStr_0(this.s9t_1) + ', ' + get_niceStr_0(this.t9t_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.q9t_1);
    result = imul(result, 31) + getNumberHashCode(this.r9t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s9t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t9t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.q9t_1, tmp0_other_with_cast.q9t_1))
      return false;
    if (!equals(this.r9t_1, tmp0_other_with_cast.r9t_1))
      return false;
    if (!equals(this.s9t_1, tmp0_other_with_cast.s9t_1))
      return false;
    if (!equals(this.t9t_1, tmp0_other_with_cast.t9t_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.u9t_1 = new Vector3F(NaN, NaN, NaN);
    this.v9t_1 = new Vector3F(0.0, 0.0, 0.0);
    this.w9t_1 = new Vector3F(1.0, 1.0, 1.0);
    this.x9t_1 = new Vector3F(0.0, 0.0, 1.0);
    this.y9t_1 = new Vector3F(0.0, 0.0, -1.0);
    this.z9t_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.a9u_1 = new Vector3F(1.0, 0.0, 0.0);
    this.b9u_1 = new Vector3F(0.0, 1.0, 0.0);
    this.c9u_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_20();
    this.d9u_1 = x;
    this.e9u_1 = y;
    this.f9u_1 = z;
  }
  g9u(other) {
    var dx = this.d9u_1 - other.d9u_1;
    var dy = this.e9u_1 - other.e9u_1;
    var dz = this.f9u_1 - other.f9u_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = dx * dx + dy * dy + dz * dz;
    return Math.sqrt(x);
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.d9u_1) + ', ' + get_niceStr_0(this.e9u_1) + ', ' + get_niceStr_0(this.f9u_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.d9u_1);
    result = imul(result, 31) + getNumberHashCode(this.e9u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f9u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.d9u_1, tmp0_other_with_cast.d9u_1))
      return false;
    if (!equals(this.e9u_1, tmp0_other_with_cast.e9u_1))
      return false;
    if (!equals(this.f9u_1, tmp0_other_with_cast.f9u_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    this.h9u_1 = Vector2I.e9r(0, 0);
  }
}
class Vector2I {
  constructor(x, y) {
    return new.target.e9r(x, y);
  }
  static e9r(x, y) {
    Companion_getInstance_21();
    var $this = createThis(this);
    $this.b9r_1 = x;
    $this.c9r_1 = y;
    return $this;
  }
  static i9u() {
    Companion_getInstance_21();
    return this.e9r(0, 0);
  }
  d9r(that) {
    return Vector2I.e9r(this.b9r_1 - that.b9r_1 | 0, this.c9r_1 - that.c9r_1 | 0);
  }
  toString() {
    return '(' + this.b9r_1 + ', ' + this.c9r_1 + ')';
  }
  hashCode() {
    var result = this.b9r_1;
    result = imul(result, 31) + this.c9r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.b9r_1 === tmp0_other_with_cast.b9r_1))
      return false;
    if (!(this.c9r_1 === tmp0_other_with_cast.c9r_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  Companion_getInstance_0();
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  Companion_getInstance_0();
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2_0($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.v9g_1, other instanceof Angle ? other.v9g_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  Companion_getInstance_0();
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$1 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.v9g_1, other instanceof Angle ? other.v9g_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.v9g_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$1 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_10.f9h(up);
  return up.s9g_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_18().k9h_1 : up;
  Companion_getInstance_0();
  var tmp2 = y1 - y0;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  var y = x1 - x0;
  var up_0 = Companion_getInstance_18().k9h_1;
  // Inline function 'kotlin.math.atan2' call
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  var radians = Math.atan2(tmp2, y);
  var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$2, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().x9g_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().b9h_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate_0(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$1 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$1);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().z9g_1) <= 0) {
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians = interpolate(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians_0 = interpolate(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().b9h_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    var radians_1 = interpolate(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().b9h_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function interpolateAngleNormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, true);
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).t9h();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).u9h();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  var tmp0 = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v9h();
  // Inline function 'kotlin.math.min' call
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w9h();
  return Math.min(tmp0, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  var tmp0 = _BoundsBuilder___get_bounds__impl__s1l1gx($this).v9h();
  // Inline function 'kotlin.math.max' call
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).w9h();
  return Math.max(tmp0, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  var tmp0 = _BoundsBuilder___get_bounds__impl__s1l1gx($this).x9h();
  // Inline function 'kotlin.math.min' call
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).y9h();
  return Math.min(tmp0, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  var tmp0 = _BoundsBuilder___get_bounds__impl__s1l1gx($this).x9h();
  // Inline function 'kotlin.math.max' call
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).y9h();
  return Math.max(tmp0, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).t9h())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().m9i(p, Size2D.l9i(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().i9i(Companion_getInstance_18().o9i(_BoundsBuilder___get_bounds__impl__s1l1gx($this).n9i(), p), Companion_getInstance_18().q9i(_BoundsBuilder___get_bounds__impl__s1l1gx($this).p9i(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.t9h())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.n9i()), rect.p9i());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.s2();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.u2(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.p1();
  while (_iterator__ex2g4s.q1()) {
    var it = _iterator__ex2g4s.r1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.r9i_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_9().y9o(rect.v9h(), rect.w9h(), rect.y9h(), rect.x9h(), near, far);
}
function get_scale(_this__u8e3s4) {
  return Scale.e9p(_this__u8e3s4.q9m_1, _this__u8e3s4.r9m_1);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.u9l(scale.c9p_1, scale.d9p_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.f9q();
  var centerY = _this__u8e3s4.g9q();
  return new Circle(_this__u8e3s4.h9q(), Companion_getInstance_18().y9q(centerX, centerY, _this__u8e3s4.w9h(), _this__u8e3s4.x9h()));
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.t9g(_this__u8e3s4.c9p_1, _this__u8e3s4.d9p_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.b9q(toVector2(c.r9r(i)).s9r());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.b9q(toVector2(c.r9r(i)).t9r());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toFloat(_this__u8e3s4) {
  return Size2D.t9p(_this__u8e3s4.o9s_1, _this__u8e3s4.p9s_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.q9s(numberToInt(_this__u8e3s4.j9i_1), numberToInt(_this__u8e3s4.k9i_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.y9p(_this__u8e3s4.r9g_1, _this__u8e3s4.s9g_1);
}
function toDouble(_this__u8e3s4) {
  return Size2D.y9p(_this__u8e3s4.o9s_1, _this__u8e3s4.p9s_1);
}
function toPoint(_this__u8e3s4) {
  return Vector2D.t9g(_this__u8e3s4.j9i_1, _this__u8e3s4.k9i_1);
}
function plus(_this__u8e3s4, other) {
  return Vector2D.t9g(_this__u8e3s4.r9g_1 + other.j9i_1, _this__u8e3s4.s9g_1 + other.k9i_1);
}
function toVector(_this__u8e3s4) {
  return Vector2D.t9g(_this__u8e3s4.j9i_1, _this__u8e3s4.k9i_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.t9h()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.t9g(m.m9l(_this__u8e3s4.r9g_1, _this__u8e3s4.s9g_1), m.p9l(_this__u8e3s4.r9g_1, _this__u8e3s4.s9g_1));
  }
  return tmp$ret$0.r9g_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.t9h()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.t9g(m.m9l(_this__u8e3s4.r9g_1, _this__u8e3s4.s9g_1), m.p9l(_this__u8e3s4.r9g_1, _this__u8e3s4.s9g_1));
  }
  return tmp$ret$0.s9g_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.e9r(numberToInt(_this__u8e3s4.r9g_1), numberToInt(_this__u8e3s4.s9g_1));
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
var Companion_instance_21;
function Companion_getInstance_21() {
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.t9g(interpolate(_this__u8e3s4, l.r9g_1, r.r9g_1), interpolate(_this__u8e3s4, l.s9g_1, r.s9g_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).m9f = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.x9j);
initMetadataForCompanion(Companion_5);
protoOf(Margin).m9f = isAlmostEquals$default;
initMetadataForClass(Margin, 'Margin', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_7);
protoOf(Matrix).m9f = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
protoOf(MatrixTransform).m9f = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_9);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.d9o);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_11);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_12);
protoOf(Rectangle).m9f = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.f9r);
initMetadataForCompanion(Companion_14);
initMetadataForClass(RoundRectangle, 'RoundRectangle');
initMetadataForCompanion(Companion_15);
initMetadataForClass(Scale, 'Scale', Scale.n9r);
initMetadataForCompanion(Companion_16);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_17);
initMetadataForClass(Size2D, 'Size2D', Size2D.d9s);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.r9s);
initMetadataForCompanion(Companion_18);
protoOf(Vector2D).m9f = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.y9j, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_21);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.i9u);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_10 = new Companion_10();
Companion_instance_13 = new Companion_13();
Companion_instance_14 = new Companion_14();
//endregion
//region block: exports
export {
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m2b2a3p1lcfecp,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv1xrpqzvux2rki,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds27mzezsqxd8iz,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu2q6djrsmzk9ju,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun30j3tzbj9negy,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw3rdspcu2c88ii,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd3g8dzjqxtz8vj,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btdaackrnjj1mz1,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndt1h2czn61kf53d,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7k1xg6mt6atsc3s,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys29omek7j37ko1,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37k2azilpxrtd5b2,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt5vm4zpqngpunw,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on4xjct7npipfzx,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi49dr4tf51lji,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv107tog2g378xw,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy26wugwjs1otqt,
  Angle__times_impl_v3s9y2_0 as Angle__times_impl_v3s9y23l6wmhpsc1jdf,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y23mibtgzdmjehg,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf73sd8kyo0hgy9w,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fr16exly0rraiwq,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5pl35tfk7sxjoioj,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gxzjc7xpskx0n0,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1e0yj2dj19xak,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo1qjjrsvk8mf98,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xgidk87zsybva,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7x3p03svh4wzys8,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7x1zfbaumzl4uvg,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7x16kulpov94zla,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh715k068517pw6p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km3fdtbfwhjokx,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib01euopgznvvv86,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m2rcdokyluvpsy,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz3likg1inngvx3,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8jzy49udpzimry,
  Companion_getInstance as Companion_getInstancedn3d4os5eemi,
  Companion_getInstance_0 as Companion_getInstance1a9vx2vzoy0c2,
  Companion_getInstance_1 as Companion_getInstance11dw08y48m2m0,
  Companion_instance_2 as Companion_instance2yvqvvbiokzog,
  Companion_getInstance_5 as Companion_getInstance5n6ipf7m44po,
  Companion_getInstance_6 as Companion_getInstance3cokvjrertd3u,
  Companion_getInstance_7 as Companion_getInstance45f4wj6tp63r,
  Companion_getInstance_9 as Companion_getInstance1ath7o4bn4ut,
  Companion_getInstance_11 as Companion_getInstance1feyrzu0npiil,
  Companion_getInstance_12 as Companion_getInstancepzu5ca8urjqj,
  Companion_instance_13 as Companion_instance29i2v8geu7jl9,
  Companion_getInstance_16 as Companion_getInstancep1qxnlu2heww,
  Companion_getInstance_17 as Companion_getInstancenbsqt92rl0cr,
  Companion_getInstance_18 as Companion_getInstance1mhteccb9s8gp,
  Companion_getInstance_20 as Companion_getInstance1smdz541y8yio,
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstancew67nqjh3bh8t,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  Circle as Circle1sk1qi5ph1m23,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  indexOf as indexOf3tp8bzbv46hci,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Margin as Marginzmgz0t8x8vn,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  RoundRectangle as RoundRectangle271svjyf7w51p,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  interpolateAngleNormalized as interpolateAngleNormalized3h8mzdshuvgea,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  plus as plus1k1r08st2gekm,
  get_radians_0 as get_radians391vbqqjsolq6,
  get_radians as get_radians87y5j8tewvub,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toDouble as toDouble1sqmo9z3buff3,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  toPoint as toPoint1vle82q653j9s,
  toVector as toVector12s348td227ca,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
